<template>
  <div :class="wrapperClasses">
    <div
      v-for="metric in metrics"
      :key="metric.label"
      :class="metricItemClasses"
    >
      <span :class="labelClasses">{{ metric.label }}</span>
      <span :class="valueRowClasses">
        <span :class="valueClasses">{{ metric.value }}</span>
        <span :class="unitClasses">шт</span>
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    available: number;
    reserve: number;
    size?: "default" | "compact";
  }>(),
  {
    size: "default",
  },
);

const normalizedAvailable = computed(() =>
  Number.isFinite(props.available) ? Math.max(props.available, 0) : 0,
);

const normalizedReserve = computed(() =>
  Number.isFinite(props.reserve) ? Math.max(props.reserve, 0) : 0,
);

const inStock = computed(
  () => normalizedAvailable.value + normalizedReserve.value,
);

const metrics = computed(() => [
  { label: "В наличии", value: inStock.value },
  { label: "Резерв", value: normalizedReserve.value },
  { label: "Доступно", value: normalizedAvailable.value },
]);

const wrapperClasses = computed(() =>
  props.size === "compact"
    ? "grid min-w-0 grid-cols-3 gap-1.5"
    : "grid min-w-0 grid-cols-3 gap-2",
);

const metricItemClasses = computed(() =>
  props.size === "compact"
    ? "flex min-w-0 flex-col items-start justify-center rounded-[10px] bg-white-gray px-2 py-1.5 text-left"
    : "flex min-w-0 flex-col items-start justify-center rounded-[12px] bg-white-gray px-2.5 py-2 text-left",
);

const labelClasses = computed(() =>
  props.size === "compact"
    ? "whitespace-nowrap text-[8px] leading-[1.05] text-extra-text-color sm:text-[9px] xl:text-[10px]"
    : "whitespace-nowrap text-[9px] leading-[1.05] text-extra-text-color sm:text-[10px] xl:text-[11px]",
);

const valueClasses = computed(() =>
  props.size === "compact"
    ? "text-[14px] leading-none font-helvetica-700 text-gray-dark sm:text-[15px] xl:text-[16px]"
    : "text-[15px] leading-none font-helvetica-700 text-gray-dark sm:text-[16px] xl:text-[17px]",
);

const unitClasses = computed(() =>
  props.size === "compact"
    ? "text-[9px] leading-none text-extra-text-color sm:text-[10px]"
    : "text-[10px] leading-none text-extra-text-color sm:text-[11px]",
);

const valueRowClasses = computed(() =>
  props.size === "compact"
    ? "inline-flex items-baseline justify-start gap-1 whitespace-nowrap tabular-nums"
    : "inline-flex items-baseline justify-start gap-1.5 whitespace-nowrap tabular-nums",
);
</script>
